// extracted by mini-css-extract-plugin
export default {"page__container":"Layout_page__container__q0uMs"};